import browser from './browser';

const vendorPrefix = () => {
  const prefix = {
    'ie11': '-ms-',
    'ie10': '-ms-',
    'chrome': '-webkit-',
    'opera': '-o-',
    'firefox': '-moz-',
    'safari': '-webkit-'
  };

  return prefix[browser()] || '';
};

export default vendorPrefix;
